<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text"
            >Inventario Histórico</CCardHeader
          >
          <CCardBody>
            <CRow class="mb-3">
              <CCol md="6" lg="6">
                <label>Almacén:</label>
                <v-select
                  v-model="almacen"
                  :options="almacenes"
                  :loading="isLoading"
                  @input="actualizarInfo()"
                  class="margin-multi"
                  placeholder="Selecciona un almacén"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6" lg="6" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  :disabled="almacen ? false : ''"
                  class="z-custom-2 mb-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
            </CRow>
            <CRow class="mb-3">
              <CCol md="6" lg="6">
                <template>
                  <CInput
                    :disabled="almacen ? false : ''"
                    v-model="filter"
                    @input="searchTimeOut()"
                    placeholder="Búsqueda..."
                  />
                </template>
              </CCol>
            </CRow>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CDataTable
              v-else
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="items"
              :fields="fields"
              :noItemsView="noItems"
            >
              <template #ALMACEN_NOMBRE="{item}">
                <td class="py-2">{{ item.almacen }}</td>
              </template>
              <template #CATEGORIA="{item}">
                <td class="py-2">{{ item.categoria }}</td>
              </template>
              <template #PRODUCTO_NOMBRE="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'InventarioHistoricoDetallado',
                      params: {
                        producto: item.producto,
                        almacen: almacen,
                        fechas: selectedDate
                      }
                    }"
                  >
                    {{ item.producto }}
                  </router-link>
                </td>
              </template>
              <template #FECHA_INICIAL="{item}">
                <td class="py-2">
                  {{ getDate(item.fecha_inicial) }}
                </td>
              </template>
              <template #FECHA_FINAL="{item}">
                <td class="py-2">
                  {{ getDate(item.fecha_final) }}
                </td>
              </template>
              <template #INVENTARIO_INICIAL="{item}">
                <td class="py-2 text-right">
                  {{ $formatter(item.inventario_inicial) }}
                </td>
              </template>
              <template #ENTRADAS="{item}">
                <td class="py-2 text-right">
                  {{ $formatter(item.entradas) }}
                </td>
              </template>
              <template #SALIDAS="{item}">
                <td class="py-2 text-right">
                  {{ $formatter(item.salidas) }}
                </td>
              </template>
              <template #INVENTARIO_FINAL="{item}">
                <td class="py-2 text-right">
                  {{ $formatter(item.inventario_final) }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import DateSelector from "../../customComponents/DateSelector";
const fields = [
  { key: "ALMACEN_NOMBRE", label: "Almacén", _style: "width:10%" },
  { key: "CATEGORIA", label: "Categoría", _style: "width:10%" },
  { key: "PRODUCTO_NOMBRE", label: "Producto Nombre", _style: "width:10%" },
  { key: "FECHA_INICIAL", label: "Fecha Inicial", _style: "width:10%" },
  { key: "FECHA_FINAL", label: "Fecha Final", _style: "width:10%" },
  {
    key: "INVENTARIO_INICIAL",
    label: "Inventario Inicial",
    _style: "width:10%; text-align: center"
  },
  {
    key: "ENTRADAS",
    label: "Entradas",
    _style: "width:10%; text-align: center"
  },
  { key: "SALIDAS", label: "Salidas", _style: "width:10%; text-align: center" },
  {
    key: "INVENTARIO_FINAL",
    label: "Inventario Final",
    _style: "width:10%; text-align: center"
  }
];

export default {
  name: "InventarioActual",

  components: {
    vSelect,
    DateSelector
  },

  data() {
    return {
      items: [],
      config: this.$route.params,
      fields,
      filter: "",
      isLoading: false,
      almacen: null,
      almacenes: [],
      almacenesAll: [],
      page: 1,
      pages: 1,
      isCreated: true,
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.almacen = this.config.almacen;
    this.selectedDate = this.config.fechas;
    this.actualizarInfo();
  },

  computed: {
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.actualizarInfo();
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.actualizarInfo();
      }, 800);
    },
    dateSelection() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },
    getDate(date) {
      return moment(String(date)).format("DD/MM/YYYY");
    },
    actualizarInfo() {
      this.isLoading = true;

      let template = {
        body: {
          reporte: "kardex_concentrado",
          params: {
            ubicaciones: [this.ubicacionRaiz],
            fecha: [
              moment(this.selectedDate?.start).format("YYYY-MM-DD"),
              moment(this.selectedDate?.end).format("YYYY-MM-DD")
            ]
          }
        }
      };

      this.almacen
        ? (template = {
            ...template,
            body: {
              ...template.body,
              params: {
                ...template.body.params,
                almacen_id: this.almacen.value
              }
            }
          })
        : null;

      this.filter != ""
        ? (template = {
            ...template,
            body: {
              ...template.body,
              params: {
                ...template.body.params,
                producto_ruta_nombre: this.filter
              }
            }
          })
        : null;

      const balance = [];

      balance.push(
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaiz]
              }
            ]
          }
        })
      );

      if (this.almacen) {
        console.log(this.almacen);
        balance.push(this.$store.dispatch("customIndicadoresHTTP", template));
      }

      Promise.all(balance)
        .then(([almacenes, saldos]) => {
          this.items = saldos != null ? saldos.data : null;

          this.almacenes = almacenes.data.map(almacen => {
            return { value: almacen.id, label: almacen.payload.nombre };
          });
          this.almacenesAll = almacenes.data;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => ((this.isLoading = false), (this.isCreated = true)));
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
